import "./ExhibitionList.css"
import ExhibitionItem from "../exhibitionItem/ExhibitionItem";

import { defaultDateFormat } from "../../utils/date";

export default function ExhibitionList(props) {
    const exhibitions = props.exhibitions
    return (
        exhibitions.length > 0 ?
            (<ul className="space-y-3">
                {exhibitions.map((exhibition) => {
                    const title = `${exhibition.clientCode}/${exhibition.productCode}`
                    return (
                        <ExhibitionItem
                            key={exhibition.id}
                            id={exhibition.id}
                            title={title}
                            trackFileStatistics={exhibition.trackFileStatistics}
                            createdAt={defaultDateFormat(exhibition.date)}
                            onEditItemClick={exhibition.onEditItemClick}
                            onViewItemClick={exhibition.onViewItemClick}
                            onQrItemClick={exhibition.onQrItemClick}
                            onDeleteClick={exhibition.onDeleteClick}
                        />
                    )
                })}
            </ul>) : (<></>)
    );
}
